import { Diagnostic, linter } from '@codemirror/lint';

// Create a reusable JSON validation function
const validateJSON = (text: string): Diagnostic[] => {
  const diagnostics: Diagnostic[] = [];
  try {
    JSON.parse(text);
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : String(e);
    diagnostics.push({
      from: 0,
      to: text.length,
      message: `Invalid JSON: ${message}`,
      severity: 'error'
    });
  }
  return diagnostics;
};

// Create the JSON linter extension for CodeMirror
export const jsonLinter = linter((view: { state: { doc: { toString: () => string } } }) =>
  validateJSON(view.state.doc.toString())
);
